import { render } from "./MainModal.vue?vue&type=template&id=226bc7f8"
import script from "./MainModal.vue?vue&type=script&lang=js"
export * from "./MainModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__